import { createAsyncThunk } from "@reduxjs/toolkit";
import { RESETPASSWORD_API_URL } from "@custom/constant";
import { ResetPasswordFormTypes } from "../../Auth/helper/auth";

const resetPasswordApi = createAsyncThunk('login', async (resetPasswordData: ResetPasswordFormTypes) => {
    const response = await fetch(RESETPASSWORD_API_URL, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(resetPasswordData),
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message || 'Login failed');
    }
    return data;
});

export default resetPasswordApi;
